import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {selectVenueName} from '../../store/slices/venue/slice';

const suffix = 'Treatwell';

export const Title = ({
  isAvailabilty,
  isReschedule,
}: {
  isReschedule?: boolean;
  isAvailabilty?: boolean;
}): null => {
  const {t} = useTranslation();
  const venueName = useSelector(selectVenueName);

  let title = '';
  if (isAvailabilty) {
    title = t('pageTitle.availability', {venueName});
  }
  if (isReschedule) {
    title = t('pageTitle.reschedule');
  }

  useEffect(() => {
    document.title = `${title} | ${suffix}`;
  }, [title]);

  return null;
};
